export default __webpack_public_path__ + "static/media/presidents1.cc7ca5b2.png";